import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeVehicle } from '../../redux/actions/vehicles';

interface Props {
  match: any;
  handleRemoveVehicle: Function;
}

const Route = ({ match, handleRemoveVehicle }: Props) => (
  <RouteWrapper
    title="Remove Vehicle"
    requireAuth
    requirePermission="MANAGE_VEHICLES"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Vehicle?</Title>
      <Subtitle>
        <p>
          Once this vehicle is removed, you will not be able to use it anymore.
        </p>
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveVehicle(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Vehicle
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/settings/vehicles/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveVehicle: (id) => {
    dispatch(removeVehicle(id)).then((response) => {
      if (!response.error) {
        dispatch(goBack());
        dispatch(goBack());
      } else {
        window.alert(response.error);
        dispatch(goBack());
      }
    });
  },
});

export default connect(
  () => ({}),
  mapDispatchToProps,
)(Route);
